<div class="padding">
  <h1 class="left-box">{{ 'orderAuditList.auditQueue' | transloco }}</h1>

  @if (repo.resource$ | async; as data) {
    <div>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="bold">
            {{ 'common.labels.filters' | transloco }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- Optional Filter -->
        <app-order-audit-filter></app-order-audit-filter>
      </mat-expansion-panel>
      <div class="spacer-small"></div>
      <!-- Clients Table -->
      <div class="table-container">
        <!-- Conditional paginator at the top (show only when number of orders displayed is >= 50) -->
        @if (data.length >= 50) {
          <div>
            <mat-paginator [pageSize]="this.repo.pageSize$ | async"
              [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
              [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
            (page)="page($event)"></mat-paginator>
            <div class="spacer-small"></div>
          </div>
        }
        <!-- End of conditional paginator at the top -->
        @if (data.length > 0) {
          <table mat-table matSort [dataSource]="data" multiTemplateDataRows
            (matSortChange)="sort($event)">
            <!-- Corporation Column -->
            <ng-container matColumnDef="corporation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'common.labels.corporation' | transloco }} </th>
              <td mat-cell *matCellDef="let audit"> {{ audit.orderCorporationID }} </td>
            </ng-container>
            <!-- Order Type Column -->
            <ng-container matColumnDef="orderTypeID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'common.labels.orderType' | transloco }} </th>
              <td mat-cell *matCellDef="let audit"> {{ audit.orderTypeID | enumLabel:'orderType' }} </td>
            </ng-container>
            <!-- Country Column -->
            <ng-container matColumnDef="orderCountry">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'common.labels.country' | transloco }} </th>
              <td mat-cell *matCellDef="let audit"> {{ audit.orderCountry }} </td>
            </ng-container>
            <!-- Jurisdiction Column -->
            <ng-container matColumnDef="orderJurisdiction">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'common.labels.jurisdiction' | transloco }} </th>
              <td mat-cell *matCellDef="let audit"> {{ audit.orderJurisdiction }} </td>
            </ng-container>
            <!-- Audit Passed Column -->
            <ng-container matColumnDef="auditStateID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'orderAuditList.audit' | transloco }} </th>
              <td mat-cell *matCellDef="let audit"> {{ audit.auditStateID | enumLabel:'auditState' }} </td>
            </ng-container>
            <!-- Audit Date Column -->
            <ng-container matColumnDef="auditeDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'orderAuditList.auditDate' | transloco }} </th>
              <td mat-cell *matCellDef="let audit"> {{ audit.auditDate | utcToLocalDate }} </td>
            </ng-container>
            <!-- Audit By Column -->
            <ng-container matColumnDef="auditedByName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'orderAuditList.auditedBy' | transloco }} </th>
              <td mat-cell *matCellDef="let audit"> {{ audit.auditedByName }} </td>
            </ng-container>
            <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
              <td mat-cell *matCellDef="let order">
                <button mat-icon-button color="accent" (click)="viewOrder(order, false)" [attr.aria-label]="'common.labels.viewOrder' | transloco">
                  <mat-icon>article</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="viewOrder(order, true)" [attr.aria-label]="'common.labels.viewOrder' | transloco">
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </td>
            </ng-container>
            <!-- Header and Row Declarations -->
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
          </table>
        }
        @if (data.length > 0) {
          <mat-paginator [pageSize]="this.repo.pageSize$ | async"
            [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
            [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
          (page)="page($event)"></mat-paginator>
        }
        <!-- End of paginator for the bottom -->
      </div>
      @if (repo.loading$ | async) {
        <div class="loading-spinner-overlay">
          <mat-spinner></mat-spinner>
        </div>
      }
      <!-- End of spinner -->
      <lib-placeholder [iconName]="'cancel'" [iconClass]="'icon-error'" [message]="'orderAuditList.errorLoadingOrderAudits' | transloco"
      [condition]="(this.repo.error$ | async) ?? false"></lib-placeholder>
    </div>
  }
</div>